import { render, staticRenderFns } from "./IconSortDesc.vue?vue&type=template&id=59f5edd6&"
import script from "./IconSortDesc.vue?vue&type=script&lang=js&"
export * from "./IconSortDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f5edd6')) {
      api.createRecord('59f5edd6', component.options)
    } else {
      api.reload('59f5edd6', component.options)
    }
    module.hot.accept("./IconSortDesc.vue?vue&type=template&id=59f5edd6&", function () {
      api.rerender('59f5edd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSortDesc.vue"
export default component.exports